export { Modal, ModalVariant, ModalSize} from './modal';
export type { ModalProps } from './modal';
